import React from 'react';
import {LocalizationContext} from '../LocalizationContext/LocalizationContext';
import {localizeUrl} from '@homeaway/localization-utils';

class Link extends React.Component {
    render() {
        let {children, href, ...props} = this.props;
        return (<LocalizationContext.Consumer>
            {(siteContext) => {
                const localizedUrl = localizeUrl(href, siteContext);
                if (typeof children === 'function') {
                    return children(localizedUrl);
                }
                return (
                    <a href={localizedUrl} {...props} >
                        {children}
                    </a>
                );
            }}
        </LocalizationContext.Consumer>);
    }
}

export default Link;
